/*******************
* Cookies handler *
*******************/
window.Cookies = window.Cookies || {
  // https://stackoverflow.com/a/25490531/1028230
  get: function (cookieName) {
    var b = document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)');
    var v = b ? b.pop() : '';
    try { return decodeURIComponent(v); } catch (e) { return v; }
  },
  set: function (name, value) {
    var v = value;
    try { v = encodeURIComponent(value); } catch (e) {}
    document.cookie =
      '{0}={1};expires=Fri, 31 Dec 9999 23:59:59 GMT;path=/;SameSite=Lax'
        .replace('{0}', name)
        .replace('{1}', v);
  },
  delete: function (name) {
    document.cookie =
      '{0}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; SameSite=Lax'
        .replace('{0}', name);
  }
};

// Back-compat aliases (js-cookie uses remove())
window.Cookies.remove = window.Cookies.remove || window.Cookies.delete;